<template>
    <div>
        <a-modal :title="modalState.title" :visible="modalState.isShow" :confirm-loading="confirmLoading" width="950px" @cancel="handleCancel">
            <a-form-model :model="searchP" layout="inline" ref="searchform" :form="form" style="margin-bottom:20px;">

                <a-form-model-item label="所属领域" prop="domain">
                    <a-select v-model="searchP.domain" style="width:100px" placeholder="请选择服务所属领域">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="001">前台</a-select-option>
                        <a-select-option key="002">中台</a-select-option>
                        <a-select-option key="003">开放</a-select-option>
                        <a-select-option key="004">基础</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-item label="系统编码">
                    <SysAutoComplete ref="syscodeAss" @onSysCodeChange="handleSearchSyscodeChange"></SysAutoComplete>
                </a-form-item>
                <a-form-model-item prop="sysname" label="系统名称">
                    <a-input v-model="searchP.sysname" placeholder="请输入系统名称"></a-input>
                </a-form-model-item>

                <a-form-model-item>
                    <a-button type="primary" @click="handleSubmit">筛选</a-button>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="default" @click="handleSearchReset">重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>

            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:modalState.rowsType,getCheckboxProps:getCheckboxProps}" :columns="columns" :data-source="list" rowKey="syscode" :pagination="false" />

            <br />

            <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" style="float:right;" show-less-items />
            <br />

            <template slot="footer">
                <div style="float:left;font-weight:bolder;color:green;">已选：{{selectedRowKeys.length}}</div>

                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>
import SysAutoComplete from './SysCodeAutoComplete.vue'
const columns = [
    {
        title: '所属领域',
        dataIndex: 'domainname',
        align: 'center',
        width: 80,
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width: 80,
    },
    {
        title: '系统名称',
        dataIndex: 'sysname',
        align: 'center',
        width: 120,
        ellipsis: true,
    },
]

export default {
    data() {
        return {
            confirmLoading: false,
            columns: columns,
            selectedRowKeys: [],
            list: [],
            searchVal: '',
            pagination: {
                total: 0,
                pageSize: 10,
                current: 1,
            },
            searchP: {
                domain: this.modalState.domain,
                syscode: '',
                sysname: '',
            },
            form: this.$form.createForm(this),
            originData: [],
            savedPages: [],
            getCheckboxProps: (record) => ({
                props: {
                    disabled: record.disabled, // Column configuration not to be checked
                },
            }),
        }
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0
        },
    },
    props: {
        modalState: {
            isShow: false,
            rowsType: 'checkbox',
            selectkeys: [],
            domain: '',
        },
    },
    methods: {
        handleSearchSyscodeChange(value) {
            this.searchP.syscode = value
        },
        handlePageChange(params_page) {
            this.onModalInit(params_page)
        },
        handleSubmit() {
            this.onModalInit(1)
        },
        handleSearchReset() {
            this.searchP = {
                syscode: '',
                sysname: '',
                domain: '',
            }
            this.onModalInit(1)
        },
        onModalInit(pageNum) {
            let that = this
            let c_params = {
                pageSize: that.pagination.pageSize,
                page: pageNum ? pageNum : 1,
                urlparams: false,
            }
            c_params.syscode = that.searchP.syscode
            c_params.domain = that.searchP.domain
            c_params.sysname = that.searchP.sysname

            that.$store
                .dispatch({
                    type: 'sys/selectSys',
                    params: c_params,
                    showMsg: false,
                })
                .then((res) => {
                    if (res.data.success == 1) {
                        let result = res.data.data
                        result.list.forEach((element) => {
                            element.disabled =
                                this.modalState.selectkeys.indexOf(
                                    element.syscode
                                ) != -1
                        })
                        if (that.modalState.selectkeys.length > 0) {
                            that.selectedRowKeys = that.modalState.selectkeys
                        }
                        that.originData = that.originData.concat(result.list)
                        that.list = result.list
                        that.pagination.total = result.totalRecords
                        that.pagination.pageSize = result.pageSize
                        that.pagination.current = result.page
                    } else {
                        that.message.error('获取系统列表失败')
                    }
                })
        },

        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleOk() {
            let current_keys = this.selectedRowKeys
            let result = []
            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index]
                let c_item = this.originData.filter(function (n) {
                    return element == n.syscode
                })
                if (c_item.length == 0) {
                    result = undefined
                    console.log('未找到对应数据')
                    break
                }
                result.push(c_item[0])
            }

            this.$emit('onModalHide', result)
            this.selectedRowKeys = []
        },
        handleCancel(e) {
            e.preventDefault()
            this.selectedRowKeys = []
            this.modalState.isShow = false
            this.$emit('onModalHide', undefined)
        },
    },
    mounted() {},
    components: {
        SysAutoComplete,
    },
    watch: {
        'modalState.isShow'(newVal) {
            if (newVal) {
                let oringin_data = []
                this.modalState.selectkeys.forEach((element) => {
                    oringin_data.push({
                        syscode: element,
                    })
                })
                this.originData = oringin_data

                this.onModalInit(1)
            }
        },
    },
}
</script>

<style scoped>
</style>
